export const capper = (value: number, upperLimit?: number, prefix?: string) => {
  if (upperLimit && value > upperLimit) {
    return prefix ? `${prefix}${upperLimit}` : upperLimit;
  }

  let divider = 10;

  if (value <= divider) {
    return value;
  }

  let result = value / divider;
  while (result > 10) {
    divider *= 10;
    result = value / divider;
  }

  const factor = Math.floor(result);
  const _value = !factor ? value : factor * divider;
  return prefix ? `${prefix}${_value}` : _value;
};
